'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactQrSvg = require('react-qr-svg');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import QRCode from 'react-qr-code';
var QRStatus = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(QRStatus, _Component);

  function QRStatus() {
    (0, _classCallCheck3.default)(this, QRStatus);
    return (0, _possibleConstructorReturn3.default)(this, (QRStatus.__proto__ || (0, _getPrototypeOf2.default)(QRStatus)).apply(this, arguments));
  }

  (0, _createClass3.default)(QRStatus, [{
    key: 'customStyle',
    value: function customStyle() {
      var status = this.props.status;

      var styles = require('./QRStatus.scss');
      var statusBox = styles.statusBox;
      switch (status) {
        case 'wait':
          statusBox = statusBox + ' ' + styles.wait;
          break;
        case 'accept':
          statusBox = statusBox + ' ' + styles.accept;
          break;
        case 'cancel':
          statusBox = statusBox + ' ' + styles.cancel;
          break;
        default:
          break;
      }
      return { statusBox: statusBox };
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./QRStatus.scss');
      var _props = this.props,
          QRValue = _props.QRValue,
          message = _props.message,
          label = _props.label;

      var _customStyle = this.customStyle(),
          statusBox = _customStyle.statusBox;

      return _react2.default.createElement(
        'div',
        { className: styles.box },
        _react2.default.createElement(
          'div',
          { className: styles.smallBox },
          _react2.default.createElement(
            'div',
            { className: styles.loadingBox },
            QRValue && _react2.default.createElement(_reactQrSvg.QRCode, {
              value: QRValue,
              style: { width: '125px', height: '125px' }
            })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.textBox },
            _react2.default.createElement(
              'div',
              { className: styles.message },
              '* ',
              message
            ),
            _react2.default.createElement(
              'div',
              { className: statusBox },
              _react2.default.createElement(
                'label',
                null,
                label
              )
            )
          )
        )
      );
    }
  }]);
  return QRStatus;
}(_react.Component), _class.propTypes = {
  status: _react.PropTypes.string,
  QRValue: _react.PropTypes.string,
  message: _react.PropTypes.string,
  label: _react.PropTypes.string,
  countDown: _react.PropTypes.string
}, _temp);
exports.default = QRStatus;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/Booking/QRStatus.js
// module id = 1567
// module chunks = 0